import React from 'react';
import i18next from 'i18next';

import { MODALS } from '~redux/Modal/constants';
import { CLIENT_PAGES } from '~constants/pages';

import ErrorModal from '../ErrorModal';

const ErrorCheckCartModal = () => {
  return (
    <ErrorModal modalName={MODALS.ERROR_CHECK_CART}>
      <div className="column middle center text-center">
        <div className="title-medium bold m-bottom-1">{i18next.t('ErrorCheckCartModal:error')}</div>
        <div className="title-medium">{i18next.t('ErrorCheckCartModal:title')}</div>
        <div className="title-medium">{i18next.t('ErrorCheckCartModal:subtitle')}</div>
        <div className="full-width m-top-7">
          <a
            href={CLIENT_PAGES.CHECKOUT.basePath}
            type="button"
            className="row middle center button primary full-width text-light">
            {i18next.t('ErrorCheckCartModal:retry')}
          </a>
        </div>
        <div className="full-width m-top-1">
          <a href="/" className="primary text-light">
            {i18next.t('ErrorCheckCartModal:backToHome')}
          </a>
        </div>
      </div>
    </ErrorModal>
  );
};

export default ErrorCheckCartModal;
